import { MenuOutlined } from '@ant-design/icons';
import { AccordionItem } from '@mm/components';
import { SelectedContact } from '@mm/state/interfaces/contacts';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import { BotBuilderRoutes } from '../../../../../../routes/bot-builder-routes';
import { ChatVariablesTags } from '../../../../contacts/components/ContactsDetails/ContactDetailsTabs/chatVariablesTags/chatVariablesTags';
import { LinkedContacts } from './LinkedContacts';
import { Notes } from './Notes';
import { OTNTags } from './OTNTags';
import Sessions from './Sessions';

export const OtherContactDetails = ({
  selectedContact,
  onChange,
  sessionsCallback,
  onContactClick,
  withSessions,
  busy,
}: {
  selectedContact: SelectedContact;
  onChange: (busyComponent?: string) => void;
  sessionsCallback: () => void;
  onContactClick: (contact: SelectedContact) => void;
  withSessions?: boolean;
  busy?: string[];
}) => {
  const chatbotId = useSelector(activeChatbotIdSelector);
  const router = useRouter();
  const otnTags = selectedContact.tags.filter(tag => tag.kind === 'otn');
  const itemsCount =
    (selectedContact.linkedContacts?.length || 0) +
    selectedContact.tags.length +
    (withSessions ? selectedContact.sessions.length : 0) +
    selectedContact.notes.length;

  return (
    <div>
      <AccordionItem
        icon={<MenuOutlined className="contact-details__header-icon" />}
        title="Other"
        count={itemsCount}
        closeOnOutsideClick={false}
        className="contact-details__accordion-item"
        headingClassName="contact-details__accordion-item-heading"
        arrowClassName="contact-details__caret-arrow"
        headerWrapperClassName="contact-details__accordion-header-wrapper"
        caretStyleIcon
      >
        <LinkedContacts
          linkedContacts={selectedContact.linkedContacts}
          onContactClick={onContactClick}
        />
        <ChatVariablesTags
          contactId={selectedContact.id}
          selectedContact={selectedContact}
          tags={selectedContact.tags}
          onChange={onChange}
          busy={busy}
        />
        <Sessions
          contact={selectedContact}
          onSessionClick={(session, contact, setSessionIdCallback) => {
            router.history.push(
              BotBuilderRoutes.liveChat.getLink({
                chatbotId,
                remoteUserId: contact.remoteId,
              }),
            );
            setSessionIdCallback(sessionsCallback);
          }}
          withSessions={withSessions}
        />
        <Notes
          contactId={selectedContact.id}
          selectedContact={selectedContact}
          notes={selectedContact.notes}
          onChange={onChange}
          busy={busy}
        />
        <OTNTags contactId={selectedContact.id} otnTags={otnTags} />
      </AccordionItem>
    </div>
  );
};
